// extracted by mini-css-extract-plugin
export default {"container":"job-listings_container__2aiGe","isContainer":"job-listings_isContainer__3T-vH","jobListing":"job-listings_jobListing__15y_G"};